import types from './types';

const INITIAL_STATE = {
  isFetchingSpecific: false,
  isFetchingMeasures: false,
  isFetchingDetail: false,
  isAdding: false,
  isFetchingDetailPrintFile: false,

  result: [],
};

const authHCCReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_MEMBER_MEASURES_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingMeasures: true,
      };

    case types.GET_MEMBER_MEASURES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingMeasures: false,
      };

    case types.GET_MEMBER_MEASURES_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingMeasures: false,
      };

    case types.ADD_TO_HCC_DOCS_REQUEST:
      return {
        ...state,
        result: [],
        isAdding: true,
      };

    case types.ADD_TO_HCC_DOCS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isAdding: false,
      };

    case types.ADD_TO_HCC_DOCS_FAILURE:
      return {
        ...state,
        result: [],
        isAdding: false,
      };

    case types.GET_PROVIDER_HCC_MEMBER_DETAIL_PRINT_FILE_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingDetailPrintFile: true,
      };

    case types.GET_PROVIDER_HCC_MEMBER_DETAIL_PRINT_FILE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingDetailPrintFile: false,
      };

    case types.GET_PROVIDER_HCC_MEMBER_DETAIL_PRINT_FILE_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingDetailPrintFile: false,
      };

    default:
      return state;
  }
};

export default authHCCReducer;
